import { render, staticRenderFns } from "./ListUsers.vue?vue&type=template&id=8b6b2844&scoped=true&"
import script from "./ListUsers.vue?vue&type=script&lang=js&"
export * from "./ListUsers.vue?vue&type=script&lang=js&"
import style0 from "./ListUsers.vue?vue&type=style&index=0&id=8b6b2844&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6b2844",
  null
  
)

export default component.exports